import * as NetteAjax from './NetteAjax';

export function applyTo(selector) {
    document.addEventListener('click', function(event) {
        let target = event.target || event.srcElement;

        while(target !== null && target.matches(selector) === false) {
            target = target.parentElement;
        }

        if(target) {
            console.log('999');
            event.preventDefault();
            processLink(target);
        }
    });
}

function processLink(link)
{
    return NetteAjax.sendRequest(
        {
            url: link.getAttribute('href')
        }
    );
}
